/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Scope_Both_HintInputs */

const cs_ebr_scope_both_hint = /** @type {(inputs: Ebr_Scope_Both_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejdřív makléři, aby se k nim nabídky spárovaly.`)
};

const en_ebr_scope_both_hint = /** @type {(inputs: Ebr_Scope_Both_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brokers first so offers can pair to them.`)
};

/**
* | output |
* | --- |
* | "Brokers first so offers can pair to them." |
*
* @param {Ebr_Scope_Both_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_scope_both_hint = /** @type {((inputs?: Ebr_Scope_Both_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Scope_Both_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_scope_both_hint(inputs)
	return cs_ebr_scope_both_hint(inputs)
});